import React from "react";
import { Boxes, Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import BatchStatCard from "./BatchStatCard";

const BatchSummaryCards = ({ totalBatches, wipBatches, completedBatches, holdParts, reworkParts, rejectParts }) => (
  <div className="grid grid-cols-2 gap-3 pb-4 sm:grid-cols-4">
    <BatchStatCard icon={Boxes} label="Total Batches" value={totalBatches} hint="All batches matching the current filters." />
    <BatchStatCard icon={Loader2} label="WIP Batches" value={wipBatches} hint="Batches currently in progress." />
    <BatchStatCard icon={CheckCircle2} label="Completed Batches" value={completedBatches} hint="Batches fully processed." />
    <BatchStatCard icon={AlertTriangle} label="Hold Parts" value={holdParts ?? "—"} hint="Non-good parts across all batches matching the current filters.">
      <div className="mt-2 grid grid-cols-2 divide-x divide-slate-100 text-xs text-slate-500">
        <div>Rework <span className="block font-semibold text-amber-600">{reworkParts ?? "—"}</span></div>
        <div className="pl-3">Reject <span className="block font-semibold text-rose-600">{rejectParts ?? "—"}</span></div>
      </div>
    </BatchStatCard>
  </div>
);

export default BatchSummaryCards;
